function isPlainObject(value: unknown): value is Record<string, unknown> {
    if (value === null || typeof value !== 'object') return false;
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

export type DeepPartial<T> =
    T extends Array<infer U>
        ? Array<DeepPartial<U>>
        : T extends ReadonlyArray<infer U>
            ? ReadonlyArray<DeepPartial<U>>
            : T extends object
                ? { [K in keyof T]?: DeepPartial<T[K]> }
                : T;

export function deepMerge<T>(target: T, source: DeepPartial<T>): T;
export function deepMerge<T>(target: T | undefined, source: DeepPartial<T>): T;
export function deepMerge<T>(target: T | undefined, source: DeepPartial<T>): T {
    if (source === undefined || source === null) return target as T;

    if (!isPlainObject(target) || !isPlainObject(source)) {
        return source as T;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result: any = { ...(target as any) };

    for (const [key, value] of Object.entries(source)) {
        const prev = result[key];

        if (Array.isArray(value)) {
            result[key] = value;
            continue;
        }

        if (isPlainObject(prev) && isPlainObject(value)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result[key] = deepMerge(prev, value as any);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result[key] = value as any;
        }
    }

    return result as T;
}
